import { render, staticRenderFns } from "./TaskTypeList.vue?vue&type=template&id=d3b94d68&scoped=true"
import script from "./TaskTypeList.vue?vue&type=script&lang=js"
export * from "./TaskTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b94d68",
  null
  
)

export default component.exports